<template>
    <div id="itemTaxes">
        <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} {{$t('i_Taxes')}}</h6>
        <span v-show="collaps">
            <b-form-checkbox v-show="taxes.tx1.active" switch :size="chkSize" v-model="chkTx1">{{taxes.tx1.name}} <span class="txRate">({{taxes.tx1.rate}}%)</span></b-form-checkbox>
            <b-form-checkbox v-show="taxes.tx2.active" switch :size="chkSize" v-model="chkTx2">{{taxes.tx2.name}} <span class="txRate">({{taxes.tx2.rate}}%)</span></b-form-checkbox>
            <b-form-checkbox v-show="taxes.tx3.active" switch :size="chkSize" v-model="chkTx3">{{taxes.tx3.name}} <span class="txRate">({{taxes.tx3.rate}}%)</span></b-form-checkbox>
            <b-form-checkbox v-show="taxes.tx4.active" switch :size="chkSize" v-model="chkTx4">{{taxes.tx4.name}} <span class="txRate">({{taxes.tx4.rate}}%)</span></b-form-checkbox>
            <b-form-checkbox v-show="taxes.tx5.active" switch :size="chkSize" v-model="chkTx5">{{taxes.tx5.name}} <span class="txRate">({{taxes.tx5.rate}}%)</span></b-form-checkbox>
            <b-form-checkbox v-show="taxes.tx6.active" switch :size="chkSize" v-model="chkTx6">{{taxes.tx6.name}} <span class="txRate">({{taxes.tx6.rate}}%)</span></b-form-checkbox>
            <!-- <pre>{{ taxesG }}</pre> -->
        </span>
        

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemTaxes',
    components: {
        
},
    props: ['Tx1', 'Tx2', 'Tx3', 'Tx4', 'Tx5', 'Tx6', 'chkSize'],
    data() {
        return {
            collaps: false,
            taxesG : this.$store.getters.getTaxes.data,
            taxes: {
                tx1: {
                    active: true,
                    name: 'Tps',
                    rate: 5,
                    include: false
                },
                tx2: {
                    active: true,
                    name: 'Tvq',
                    rate: 9.975,
                    include: false
                },
                tx3: {
                    active: true,
                    name: 'Tps inc.',
                    rate: 5,
                    include: true
                },
                tx4: {
                    active: true,
                    name: 'Tvq inc.',
                    rate: 9.975,
                    include: true
                },
                tx5: {
                    active: false,
                    name: '',
                    rate: 0,
                    include: false
                },
                tx6: {
                    active: false,
                    name: '',
                    rate: 0,
                    include: false
                }
            }
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme', 'getTaxes']),
        chkTx1: {
            get: function() {return this.Tx1},
            set: function(modifiedValue){this.$emit('update:tx1', modifiedValue)}
        },
        chkTx2: {
            get: function() {return this.Tx2},
            set: function(modifiedValue){this.$emit('update:tx2', modifiedValue)}
        },
        chkTx3: {
            get: function() {return this.Tx3},
            set: function(modifiedValue){this.$emit('update:tx3', modifiedValue)}
        },
        chkTx4: {
            get: function() {return this.Tx4},
            set: function(modifiedValue){this.$emit('update:tx4', modifiedValue)}
        },
        chkTx5: {
            get: function() {return this.Tx5},
            set: function(modifiedValue){this.$emit('update:tx5', modifiedValue)}
        },
        chkTx6: {
            get: function() {return this.Tx6},
            set: function(modifiedValue){this.$emit('update:tx6', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>